/**
 * usePressState Hook
 * Manages press state for shape morphing
 */

import { useState, useMemo } from 'react';

// ============================================================================
// TYPES
// ============================================================================

export interface UsePressStateReturn {
  isPressed: boolean;
  pressHandlers: {
    onBlur: () => void;
    onMouseDown: () => void;
    onMouseLeave: () => void;
    onMouseUp: () => void;
    onTouchCancel: () => void;
    onTouchEnd: () => void;
    onTouchStart: () => void;
  };
}

// ============================================================================
// HOOK
// ============================================================================

/**
 * Hook for managing press state (for shape morphing)
 */
export function usePressState(): UsePressStateReturn {
  const [isPressed, setIsPressed] = useState(false);

  const pressHandlers = useMemo(
    () => ({
      onBlur: () => setIsPressed(false),
      onMouseDown: () => setIsPressed(true),
      onMouseLeave: () => setIsPressed(false),
      onMouseUp: () => setIsPressed(false),
      onTouchCancel: () => setIsPressed(false),
      onTouchEnd: () => setIsPressed(false),
      onTouchStart: () => setIsPressed(true),
    }),
    [],
  );

  return { isPressed, pressHandlers };
}

export default usePressState;
